<template>
  <div class="p-4">
    <div class="spinner-border text-primary mr-2" role="status" v-if="!jobData">
        <span class="sr-only">Loading...</span>
    </div>
    <div class="mb-4" v-if="jobData">
        <h5 class="mb-2">Unsere Referenz-Nr.: {{ jobData.jobId }}</h5>
        <div class="spinner-border mr-2" role="status" v-if="loading">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="job-details mb-2">
            <!-- Zeile 1 -->
            <span>Kennzeichen: {{ jobData.value.vehicle.registrationDetails.registrationPlate }} | {{ jobData.value.vehicle.typeDetails.manufacturer }} {{ jobData.value.vehicle.typeDetails.model }} {{ jobData.value.vehicle.typeDetails.productionSeries }}</span>
            <!-- Zeile 2 -->
            <span v-if="jobData.value.progressInfo.progress == 30">Erfasst</span>
            <span v-if="jobData.value.progressInfo.progress == 40">Angebot erstellt</span>
            <span v-if="jobData.value.progressInfo.progress == 50 || jobData.value.progressInfo.progress == 90">Beauftragt</span>
            <span v-if="jobData.value.progressInfo.progress == 100">Fakturiert</span>
        </div>
        <div class="row">
            <div class="col-sm-4">{{ jobData.value.progressInfo.textLeft }}</div>
            <div class="col-sm-4"><img :src="jobData.value.progressInfo.imageUri" class="img-fluid" :alt="jobData.value.progressInfo.imageText"><br />{{ jobData.value.progressInfo.imageText }}</div>
            <div class="col-sm-4">{{ jobData.value.progressInfo.textRight }}</div>
        </div>
        <div>
            <h6>Sie haben folgende Optionen:</h6>
            <div v-if="$parent.content.setting_kl !== 0">
              <button class="btn btn-primary my-1 mr-1" @click="onViewingAppointmentFromJob()" v-if="jobData.value.progressInfo.progress == 30 && (jobData.value.progressInfo.vehicleState < 10 || jobData.value.progressInfo.vehicleState == 70)">Besichtigungstermin vereinbaren/ändern</button>
            </div>
            <button class="btn btn-primary my-1 mr-1" @click="onOnlineOfferDocuments()" v-if="jobData.value.progressInfo.progress >= 30 && jobData.value.progressInfo.progress <= 50">Bilder und Dokumente übertragen</button>
            <hr />
            <KSRMessageToBodyshop :jobId="jobData.jobId" :storeId="storeId" />
        </div>
    </div>
  </div>
</template>

<script>
import KSRMessageToBodyshop from "./KSRMessageToBodyshop";
export default {
    name: "KSRSingleJob",
    components: { KSRMessageToBodyshop },
    data() {
        return {
        	jobData: false,
            loading: false,
        }
    },
	mounted() {
		let _this = this;
	    // check for booklyn token to view job directly
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const booklyn_token = urlParams.get('t');
        if(booklyn_token) {
            let url = '/api/ksr/booklyn-token/' + booklyn_token;
            axios.get(url)
            .then((response) => {
                _this.jobData = response.data;
                _this.$emit('eventname', response.data);
            });
        }
	},
    methods: {
        onViewingAppointmentFromJob() {
            this.$parent.onViewingAppointmentFromJob();
        },
        onOnlineOfferFromJob() {
            this.$parent.onOnlineOfferFromJob();
        },
        onOnlineOfferDocuments() {
            this.$parent.onOnlineOfferDocuments();
        }
    },
    props: ['storeId']
};
</script>

<style>

</style>
